import React from "react";

const Disconnected = () => {
    return (
        <div>
            Disconnected
        </div>
    )
}

export default Disconnected;